<template>
  <!-- 全部栏目 -->
  <div>
    <!-- 搜索框 -->
    <scroller :on-refresh="refresh">
      <div class="container">
        <div class="row">
          <div class="col-md-8" style="margin:0 auto">
            <Search />

            <!-- 导航栏 -->
            <div class="catImg">
              <img :src="catDetail.catCoverImg" preview @click="getCatDetail()" alt />
            </div>

            <mt-navbar v-model="selected" style="width:50%" v-show="columnList.length===1">
              <mt-tab-item
                :id="item.catId"
                v-for="(item,index) in columnList"
                :key="index"
              >{{item.catName}}</mt-tab-item>
            </mt-navbar>

            <mt-navbar v-model="selected" v-show="columnList.length>1">
              <mt-tab-item
                :id="item.catId"
                v-for="(item,index) in columnList"
                :key="index"
              >{{item.catName}}</mt-tab-item>
            </mt-navbar>

            <!-- 列表显示区域 -->
            <mt-tab-container v-model="selected">
              <!-- 二级分类区 -->
              <mt-tab-container-item
                :id="item.catId"
                v-for="(item,index) in columnList"
                :key="index"
              >
                <div class="navItem">
                  <info-item :catId="item.catId"></info-item>
                </div>
              </mt-tab-container-item>
            </mt-tab-container>
          </div>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
import Search from '../../components/Search'
import InfoItem from '../../components/InfoItem'
export default {
  beforeRouteLeave(to, from, next) {
    if (to.name === 'Details') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  },
  components: { Search, InfoItem },
  data() {
    return {
      catId: this.$route.query.catId,
      selected: this.$route.query.catId,
      columnList: [],
      timer: '',
      catDetail: {},
      fixed: false,
    }
  },
  mounted() {
    this.getColumnList()
    this.getColumn()
    this.noShare()
  },
  methods: {
    refresh() {
      location.reload()
    },
    // 跳转到分类详情
    getCatDetail() {
      this.$router.push({
        path: '/catDetail',
        query: {
          catId: this.catId,
        },
      })
    },
    // 获取主题
    getColumn() {
      this.$http({
        url: `live/liveCategory/info/${this.catId}`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.catDetail = data.data
        } else {
          this.catDetail = []
        }
      })
    },
    // 获取栏目列表
    getColumnList() {
      this.$http({
        url: `live/liveCategory/queryCategoryChildren/${this.catId}`,
        methods: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          let arr = []
          this.getChildrens(arr, data.data[0])
          this.selected = arr[0].catId
          this.columnList = arr
        }
      })
    },
    getChildrens(arr, node) {
      arr.push(node)
      node.children.forEach((e) => {
        this.getChildrens(arr, e)
      })

      if (
        node.children === null ||
        node.children === undefined ||
        node.children === '' ||
        node.children.length < 1
      ) {
        return arr
      }

      return arr
    },
  },
}
</script>

<style lang='scss' scoped>
.catImg {
  width: 100%;
  height: 20rem;
  padding: 1rem;
  padding-top: 0;
  border-bottom: 5px solid #eee;
  img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}
/deep/ .mint-tab-container {
  margin: 1rem;
}
/deep/ .mint-navbar {
  width: 100%;
  overflow-x: scroll;
  white-space: nowrap;
  /deep/ .mint-tab-item {
    margin: 0 1rem;
    display: inline-block;
  }
}
/* 每一个图文项目的外层 */
a {
  text-decoration: none;
  color: #333;
}
.inforItemText {
  margin-left: 2rem;
  width: 65%;
}
/* 图文项目的标题信息 */
.infoItemTitle {
  font-size: $font-title;
  overflow: hidden;
  margin-bottom: 2rem;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
/* 图文项目的内容信息(弹性布局) */
.infoItemContent:last-child {
  border-bottom: 0;
}
.infoItemContent {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  margin: 0.2rem 0;
  width: 100%;
  border-bottom: 1px solid rgb(116, 114, 114);
  .liveImg {
    position: relative;
    .liveStatus {
      position: absolute;
      right: 0;
      bottom: 0.5rem;
      color: #fff;
      padding: 2px 1rem;
      border-radius: 1rem;
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }
}
/* 图文项目的内容信息--图片 */
.infoItemImg {
  width: 15rem;
  height: 10rem;
  border-radius: 5px;
}
/* 图文项目的内容信息--简介 */
.infoItemDes {
  line-height: 20px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.infoItemPrice {
  font-size: $font-price;
  color: #999;
  .free {
    padding: 0.5rem 1rem;
    margin-right: 1rem;
    background-color: $theme-color;
    border-radius: 0.5rem;
    color: #fff;
  }
  .price {
    margin-right: 1rem;
    color: $theme-color;
  }
}
.tabbar::-webkit-scrollbar {
  display: none;
}
.tabbar {
  margin: 2rem 1rem;
  display: flex;
  overflow: scroll;
  width: 100%;
  border-top: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  span {
    text-align: center;
    flex-shrink: 0;
    width: 6rem;
    margin: 1rem;
    margin-bottom: 0;
    padding-bottom: 1rem;
  }
  .active {
    border-bottom: 2px solid $theme-color;
  }
}
.tabbarContext {
  margin: 0 1rem;
}
</style>
